module.exports = __webpack_public_path__ + "img/SBG_welocme_logo_1.96b699d5.svg";